module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "nft-wevr.683bb794.png";